import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AppHands from '../../assets/icons/app_hands.svg';
import OnboardingBackground from '../../components/OnboardingBackground';
import OnboardingCardTemplate from '../../components/OnboardingCardTemplate';
import { useAmplitude } from '../../providers/AmplitudeProvider';
import { ILink } from '../../services/link/types';
import {
    onWebAppOrganizationAcceptClicked,
    onWebAppShareLinkLoaded,
} from '../../tracking/trackers';

const OrganizationLink = ({
    linkToken,
    tokenData,
}: {
    linkToken: string;
    tokenData: ILink;
}) => {
    const navigate = useNavigate();
    const { isInitialized } = useAmplitude();

    const organizationName = tokenData?.metadata?.organization_name;

    useEffect(() => {
        if (isInitialized) {
            onWebAppShareLinkLoaded({
                share_token: linkToken,
            });
        }
    }, [isInitialized]);

    return (
        <>
            <OnboardingBackground>
                <OnboardingCardTemplate
                    title={"You've been invited to join " + organizationName}
                    content={
                        <>
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                }}
                            >
                                <img
                                    src={AppHands}
                                    alt=""
                                    width={150}
                                    height={150}
                                    style={{ marginTop: 30 }}
                                />
                            </div>
                        </>
                    }
                    buttons={[
                        {
                            text: 'Accept Invite',
                            onClick: () => {
                                onWebAppOrganizationAcceptClicked({
                                    organization_token: linkToken,
                                });
                                navigate(
                                    '/signup?manualCodeEntry=true&variant=share&organization_token=' +
                                        linkToken +
                                        '&suggested_mobile=' +
                                        (tokenData?.metadata?.metadata_mobile ||
                                            tokenData?.metadata?.mobile)
                                );
                            },
                        },
                    ]}
                />
            </OnboardingBackground>
        </>
    );
};

export default OrganizationLink;
